import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { RateSyncChannelService } from 'src/app/components/Shared/Service/rate-sync-channel.service';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import {ToastrService} from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { IdsProductsService } from '../Shared/Service/ids-products.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: any;
    pusheddate: any;
    type:any
}

@Component({
  selector: 'app-bwpos',
  templateUrl: './bwpos.component.html',
  styleUrls: ['./bwpos.component.css','../commonStyle.css'],
  providers: [LoginService, IdsProductsService,RateSyncChannelService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class BWPOSComponent implements OnInit {


  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  ColumnHeader: boolean;
  url: string;
  maxDate: Date;
  constructor(private apiCallForIdsProductsService: IdsProductsService,private toastr: ToastrService, private _APIRareSyncChannel: RateSyncChannelService, private datePipe: DatePipe, public loginService: LoginService) { 
    this.maxDate = new Date(this.today.setDate(this.today.getDate()));
  }
  today = new Date();
  today1:any= new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate() - 1));
  display: Boolean = false;
  totalcount: any = 0;
  hotellistCopy: any = [];
  public idsProductList: idsProductList[];
  // lstidsProductList: MatTableDataSource<idsProductList>;
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  // lstidsProductList:any;
  // dataSource:any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  UID:any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  // public LOGS: any;
  lstgetcmlist:any[];
  hotellist: any = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  // displayedColumns: string[] = ['FX_Echo_Token', 'Channel_Rate_code', 'FX_Rate_code', 'From date', 'To date', 'Currency', 'SGL_DBL_Rate', 'DH_received_date_time','DH_received_XML','DH_response_date_time','DH_response_XML', 'Channel_senddate_time','Channel_sendXML', 'ACK_date_time','Response_date_time','Status', 'XML'];
  displayedColumns: string[] = ['Status', 'hotelName', 'accountingDate', 'pusheddate', 'type'];
  ngOnInit() {
    console.log( this.url)
    this.isProgressing = true;
      this.callIDSUsersProperties();
  }

  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallForIdsProductsService.getIDSUsersProperties(this.Userid)
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          // if (data.length < 1) {
          //   this.toastr.error('Property is not activated with Channel manager');
          // }
          //Remove duplicate data
          this.apiresult = data;
          console.log('Property 113 = ', data)
          
          this.hotellist = this.apiresult.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => (mapObj.pmsname))
              .indexOf(obj.pmsname) == pos;
          });
          this.lstgetcmlist = this.apiresult.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => (mapObj.cmname))
              .indexOf(obj.cmname) == pos;
          });
          // this.selectedProperty = this.hotellist[0].pmscode;
          // this.selectedChannel = this.lstgetcmlist[0].cmcode;
          this.lstgetcmlist.unshift({
            "pmscode": "0",
            "cmcode": "All",
            "pmsname": "Select Channel",
            "cmname": "Select Channel",
            "onlinestatus": " "
          });
          this.hotellist.unshift({
            "pmscode": "0",
            "cmcode": "All",
            "pmsname": "Select Property",
            "cmname": "Select Property",
            "onlinestatus": " "
          });
          console.log("callIDSUsersProperties data? = " + JSON.stringify(data));
          
          // this.selectedProperty = "Select Property";
          // this.selectedChannel = "Select Channel";
          this.selectedProperty = this.hotellist[0].pmscode;
          this.selectedChannel = this.lstgetcmlist[0].cmcode;
          this.hotellistChannel = this.lstgetcmlist;
          this.hotellistproperty = this.hotellist;
          this.ColumnHeader = true;
          this.isProgressing=false;
          // this.PGF = 0;
          // this.PGT = 40;
          // this.GetBooking("", "");
        });
        
        
  }

  changeProperty(data: MatSelectChange) {
    console.log("selected --->" + data);
    this.Pmscodevalue = data;
    this.isProgressing = true;
    if(this.Pmscodevalue == 0){
      this.lstgetcmlist = this.hotellistChannel
      this.hotellist = this.hotellistproperty
      this.selectedChannel = this.lstgetcmlist[0].cmcode
      this.selectedProperty = this.hotellist[0].pmscode
    }else{
      var result=this.apiresult.filter(obj=> obj.pmscode == data);
      console.log(result);
      this.lstgetcmlist = result;
      this.selectedChannel = this.lstgetcmlist[0].cmcode;
      // this.lstGetCMHotelsProperty= result;
    }
    this.Val = null;
    // this.selectedChannel = this.filteredrecord[0].cmcode;
    this.isProgressing = false;
  }

  changeChannel(data) {
    console.log("selected --->" + data);
    // this.Pmscodevalue = data;
    this.isProgressing = true;
    if(data == 'All'){
      this.lstgetcmlist = this.hotellistChannel
      this.hotellist = this.hotellistproperty
      this.selectedChannel = this.lstgetcmlist[0].cmcode
      this.selectedProperty = this.hotellist[0].pmscode
    }else{
      var result=this.apiresult.filter(obj=> obj.cmcode == data);
      console.log(result);
      this.hotellist = result;
      this.selectedProperty = this.hotellist[0].pmscode;
      console.log(this.selectedProperty)
    }
    this.Val = null;
    // this.selectedChannel = this.filteredrecord[0].cmcode;
    this.isProgressing = false;
  }
  Search() {
    console.log('event= ', event)
    if (this.Val != '')
      this.hotellist = this.hotellistproperty.filter(res => {
        return res.pmsname.toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
      });
  }
  SearchChannel(event){
    console.log('event= ', event)
    if (this.Val != '')
      this.lstgetcmlist = this.hotellistChannel.filter(res => {
        return res.cmname.toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
      });
  }

  getchannellist(Pmscodevalue: any) {
    console.log(this.Pmscodevalue)
    this._APIRareSyncChannel.getCMLIST(this.Pmscodevalue)
      .subscribe(
        data => {
          console.log(data)
          if (data.length < 1) {
            this.toastr.error('Property is not activated with Channel manager');
          }
          this.lstgetcmlist = data;
          console.log(this.lstgetcmlist)
          this.selectedChannel = this.lstgetcmlist[0].cmcode;

          // this.GetTCTOPMS("undefined", "undefined");
          this.isProgressing = false;
        }
      );

    setTimeout(() => {
      console.log(this.selectedDate)
      console.log(this.selectedTOODate)
      this.callProductLogsIDS(this.selectedProperty, this.selectedDate, this.selectedTOODate, this.UID, this.typ)
    }, 1000);

  }

  loadMethodForIDSProductLog(selectedProperty: any, typ:any) {
    console.log(selectedProperty)
    console.log(this.selectedDate)
    console.log(this.selectedTOODate)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      this.callProductLogsIDS(selectedProperty, this.selectedDate, this.selectedTOODate,this.UID,typ)
    }
  }

  callProductLogsIDS(selectedProperty: any, selectedDate: any, selectedTOODate: any,UID: any,typ: any) {
    console.log(this.selectedDate)
    console.log(this.selectedTOODate)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    this.isProgressing=true;
    console.log(" selectedProperty<------->" + selectedProperty + " CMCODE<------->" + UID + " selectedDate<------->" + this.selectedDate + " selectedTooDate<------->" + this.selectedTOODate + " PGF<------->" + this.PGF + " PGT<------->" + this.PGT)
    this.apiCallForIdsProductsService.getBWPOSList(selectedProperty, this.selectedDate, this.selectedTOODate, UID, typ)
      .subscribe((res) => {
        this.StorelstRestr = res;
        this.idsProductList = res; // Bootstrap table
        // this.dataSource = this.lstidsProductList;
        console.log(this.dataSource)
        this.dataSource = new MatTableDataSource(this.idsProductList);
        this.dataSource.paginator = this.paginator;
        // this.lstidsProductList.sort = this.sort;
        if (this.idsProductList.length < 1) {
          console.log('if')
          this.toastr.error('No Data Found');
          this.isProgressing = false;
          // this.totalcount = this.lstidsProductList[0].totalRows;
          console.log(this.totalcount)
          this.ColumnHeader = false;
          
        } else {
          console.log('else')
          // console.log(this.lstidsProductList)
          // this.totalcount = this.lstidsProductList[0].totalRows;
          console.log(this.totalcount)
          this.toastr.success('Data loaded Successfully');
          this.ColumnHeader = false;
          this.isProgressing = false;
        }
      },
      error => {
        // this.totalcount = this.lstidsProductList[0].totalRows;
        this.toastr.error(JSON.stringify(error.name) +':' + JSON.stringify(error.status) +' '+JSON.stringify(error.statusText));
        this.isProgressing = false;
      }
      
      
      );
  }
  clearHotelAutoComplete(){
    this.searchText=''
  }

  // Search() {
  //   if (this.Val != '')
  //     this.hotellist = this.hotellistCopy.filter((res: { name: string; }) => {
  //       return res.name.toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
  //     });
  // }


  fromDateChange(data: any){
    console.log(data)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.toastr.error('From date should be less than To date.');
    }
  }
  pageEvent(e) {
    
    console.log(e)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // var pageIndex = e.pageIndex;
    // pageIndex = pageIndex;
    // this.pageSize = e.pageSize
    // //alert('Pagesize = '+ this.pageSize)
    // this.PGF = this.pageSize * pageIndex + 1;
    // this.PGT = this.PGF + e.pageSize - 1;
    // if(this.pageSize !=0){
    //   this.isProgressing = true;
    //   this.callProductLogsIDS( this.selectedProperty, this.selectedDate, this.selectedTOODate,this.UID, this.typ);
    // }
  } 

}
